import { createAction } from '@reduxjs/toolkit'
import { flowConfigClear } from 'redux/action.types'
import flowConfigReducer from './FlowConfig.reducer'

export const clearFlowConfigState = createAction(flowConfigClear)

export default flowConfigReducer
